/**
 * Synchronous feature detection for a hosting native WebView (MAUI HybridWebView,
 * iOS WKWebView with the webwindowinterop message handler, or Windows WebView2).
 *
 * Use this when you need to make a decision before Redux's `state.native.onWebView`
 * tri-state resolves (it stays `undefined` until MAUI sends `InitializeWebView`,
 * or for ~1s until `setOnWebViewFalseIfUndefined` fires in non-WebView contexts).
 */
export const hasWebViewHost = (): boolean => {
  const w = globalThis.window as unknown as {
    chrome?: { webview?: unknown };
    webkit?: { messageHandlers?: { webwindowinterop?: unknown } };
    hybridWebViewHost?: { sendMessage?: unknown };
  };
  return Boolean(
    w?.chrome?.webview ||
      w?.webkit?.messageHandlers?.webwindowinterop ||
      w?.hybridWebViewHost?.sendMessage
  );
};
